import React, { useState } from 'react';
import Seo from '../components/Seo';
import emailjs from 'emailjs-com';
import '../styles/contact.css';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [company, setCompany] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [content, setContent] = useState('');

  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [contentError, setContentError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    let valid = true;
    if (name.trim() === '') { setNameError('이름을 입력해주세요.'); valid = false; } else setNameError('');
    if (email.trim() === '') { setEmailError('이메일을 입력해주세요.'); valid = false; }
    else if (!email.includes('@')) { setEmailError('올바른 이메일 형식을 입력해주세요.'); valid = false; }
    else setEmailError('');
    if (content.trim() === '') { setContentError('문의내용을 입력해주세요.'); valid = false; } else setContentError('');
    if (!valid) return;

    setIsLoading(true);
    try {
      // 수신자는 EmailJS 템플릿에서 지정하므로 to_email 은 보내지 않는다.
      const templateParams = {
        company: company || '없음',
        name,
        email,
        message: content,
      };
      await emailjs.send('service_x7fyy07', 'template_diaecxf', templateParams, 'q746hI-1SPzKVRBU5');

      setSubmitted(true);
      setCompany('');
      setName('');
      setEmail('');
      setContent('');
    } catch (error) {
      if (error.status === 412) {
        alert('이메일 설정에 문제가 있습니다. 관리자에게 문의해주세요.');
      } else {
        alert('문의 전송에 실패했습니다. 다시 시도해주세요.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <Seo
        title="프로젝트 문의"
        description="웹·앱 개발 프로젝트를 상담해 드립니다. 예산과 일정, 필요한 기능을 알려 주시면 빠르게 회신드립니다."
        path="/contact"
      />
      <div className="contact-bg" aria-hidden="true">
        <video src="/images/contact_1.mp4" autoPlay loop muted playsInline></video>
        <div className="contact-bg__scrim" />
      </div>

      <div className="contact-card">
        <span className="section__eyebrow">Contact</span>
        <h1 className="contact-card__title">프로젝트 문의</h1>
        <p className="contact-card__subtitle">아이디어를 알려주시면 빠르게 회신드리겠습니다.</p>

        {submitted ? (
          <div className="contact-success">
            문의가 정상적으로 접수되었습니다. 감사합니다!
            <button
              type="button"
              className="btn btn--outline btn--sm"
              style={{ marginTop: 'var(--space-4)' }}
              onClick={() => setSubmitted(false)}
            >
              추가 문의하기
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <div className="field">
              <label className="field__label" htmlFor="c-company">회사명</label>
              <input
                id="c-company"
                className="input"
                type="text"
                placeholder="회사명을 입력해주세요"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
              />
            </div>

            <div className="field">
              <label className="field__label" htmlFor="c-name">이름<span className="req">*</span></label>
              <input
                id="c-name"
                className="input"
                type="text"
                placeholder="이름을 입력해주세요"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              {nameError && <div className="field__error">{nameError}</div>}
            </div>

            <div className="field">
              <label className="field__label" htmlFor="c-email">이메일<span className="req">*</span></label>
              <input
                id="c-email"
                className="input"
                type="email"
                placeholder="이메일을 입력해주세요"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {emailError && <div className="field__error">{emailError}</div>}
            </div>

            <div className="field">
              <label className="field__label" htmlFor="c-content">문의내용<span className="req">*</span></label>
              <textarea
                id="c-content"
                className="textarea"
                placeholder="예시) 안녕하세요. 저희 회사 앱 개발 관련하여 상담을 요청드립니다. 자세한 내용을 메일로 전달드리겠습니다."
                value={content}
                onChange={(e) => setContent(e.target.value)}
              />
              {contentError && <div className="field__error">{contentError}</div>}
            </div>

            <button type="submit" className="btn btn--accent btn--block btn--lg" disabled={isLoading}>
              {isLoading ? '전송 중...' : '문의하기'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Contact;
